import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import './stage-editor.css';

/** @class NewLayerDialog
 * A component for choosing the type of layer to
 * add to a Stage.
 */
export default class NewLayerDialog extends Component {
  render(){
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}><FontAwesome name="times"/></button>
            </div>
            <div className="dialog-content">
              <h3 className="header">New Layer</h3>
              <p>Pick your layer type:</p>
              <div className="input-group">
                <label htmlFor="image-layer-radio">
                  <input type="radio"
                    id="image-layer-radio"
                    onClick={()=>this.props.onChooseType("image")}
                    />
                  Image Layer
                </label>
                <p className="hint">
                  A single static background image
                </p>
              </div>
              <div className="input-group">
                <label htmlFor="pattern-layer-radio">
                  <input type="radio"
                    id="pattern-layer-radio"
                    onClick={()=>this.props.onChooseType("pattern")}
                    />
                  Pattern Layer
                </label>
                <p className="hint">
                  A single image repeated (tiled) across the entire stage.
                </p>
              </div>
              <div className="input-group">
                <label htmlFor="parallax-layer-radio">
                  <input type="radio"
                    id="parallax-layer-radio"
                    onClick={()=>this.props.onChooseType("parallax")}
                    />
                  Parallax Layer
                </label>
                <p className="hint">
                  A background image creating the illusion of depth by
                  scrolling a different pace than the stage.
                </p>
              </div>
              <div className="input-group">
                <label htmlFor="scroll-layer-radio">
                  <input type="radio"
                    id="scroll-layer-radio"
                    onClick={()=>this.props.onChooseType("scroll")}
                    />
                  Scrolling Layer
                </label>
                <p className="hint">
                  A repeated (tiled) image that scrolls in a cardinal direction
                </p>
              </div>
              <div className="input-group">
                <label htmlFor="animation-layer-radio">
                  <input type="radio"
                    id="animation-layer-radio"
                    onClick={()=>this.props.onChooseType("animation")}
                    />
                  Animation Layer
                </label>
                <p className="hint">
                  A series of images composing a frame-based animation
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/new-layer-dialog.js